// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { signInCreateNewAccountStyles } from "@rpsc/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    gap: 16,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    css: css`
        margin: 0;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTextGridItem = {
    width: 12,
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        font-size:14px;
        ${TypographyStyle} {
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 0;
            &:empty {
                display: none;
            }
        }
        ul {
            li {
                font-size: 14px;
                line-height: 22px;
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = { variant: "tertiary" };
